import { CREATE_TAXES, GET_TAXES } from './ApiConstants';
import api from './ApiHandler';

export const getTaxes = async (payload: any) => {
  return await api.get(GET_TAXES, { params: { ...payload } });
};

export const createTaxes = async (payload: any) => {
  return await api.post(CREATE_TAXES, { ...payload });
};
